import HelpSection from '../components/HelpBody';
import HelpTopBar from '../components/HelpTopbar'
// import ProductHowItWorks from "../components/HelpBody"
import Footer from '../components/footer'
import LandingPageFooter from '../components/LandingPagefooter'
import Navbar from "../components/navBar";
import LandingNavBar from '../components/LandingNavBar'

const HelpPage = () => {
    return (
        <div>
            <LandingNavBar />
            <HelpSection />
            <LandingPageFooter />
        </div>
    );
};

export default HelpPage;

